<template>
	<div class="datetime-component">
		
			<datepicker 
				:disabled-picker="disabled"
				v-model="dateValue"
				format="dd.MM.yyyy"
				:language="$store.state.lang === 'en' ? 'en' : 'ru'"
				:wrapper-class="disabled ? 'datetime-component-date-wrapper readonly' : 'datetime-component-date-wrapper'"
				input-class="datetime-component-date-input"
				@opened="onDateOpen"
				@closed="onDateClose"
				@selected="onDateSelect"
				:monday-first="true"
				:clear-button="!disabled" />

			<span v-if="dateValue" class="datetime-component-time" :class="{ 'focused': showTimeChoicer, 'readonly': disabled }" @click="timeChoicerShow">
				{{ timeValue }}
				<span v-if="!disabled" class="view-close" @click="zeroTime">×</span>

				<div v-show="showTimeChoicer" class="datetime-component-time-choice" @click.stop>
					<div class="datetime-component-time-choice-spiners">
						<div class="datetime-component-time-wrapper" style="width: 50%; float: left;" @mousewheel="mouseWheel('H', $event)">

							<div class="datetime-component-time-choice-spiners-button" @mousedown="moveUpStart('H')" @mouseup="moveStop('H')">&uarr;</div>
							<div class="datetime-component-time-choice-spiners-item">
								<div class="datetime-component-time-choice-spiners-hours" ref="hours">
									<div v-for="i in 24" class="datetime-component-time-choice-spiners-item">{{ i-1 }}</div>
								</div>
							</div>
							<div class="datetime-component-time-choice-spiners-button" @mousedown="moveDownStart('H')" @mouseup="moveStop('H')">&darr;</div>
							<div class="datetime-component-time-input" :class="{ 'haserror': hModelError }">
								<input ref="inputH" type="text" v-model="hModel" @input="onChangeModel('H')" @focus="focusInput('H')" maxlength="2" />
							</div>
						</div>


						<div class="datetime-component-time-wrapper" style="width: 50%; float: left;" @mousewheel="mouseWheel('M', $event)">
							<div class="datetime-component-time-choice-spiners-button" @mousedown="moveUpStart('M')" @mouseup="moveStop('M')">&uarr;</div>
							<div class="datetime-component-time-choice-spiners-item">
								<div class="datetime-component-time-choice-spiners-minutes" ref="minutes">
									<div v-for="i in 60" class="datetime-component-time-choice-spiners-item">{{ i-1 }}</div>
								</div>
							</div>
							<div class="datetime-component-time-choice-spiners-button" @mousedown="moveDownStart('M')" @mouseup="moveStop('M')">&darr;</div>
							<div class="datetime-component-time-input"  :class="{ 'haserror': mModelError }">
								<input ref="inputM" type="text" v-model="mModel" @input="onChangeModel('M')" @focus="focusInput('M')" maxlength="2" />
							</div>
						</div>

					</div>
					<div class="datetime-component-time-choice-button" @click.stop="timeChoiced">OK</div>
				</div>
			</span>

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Datepicker from 'vuejs-datepicker'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'myDateTimeComponent',
	//=========================================================================
	props: ['value', 'disabled'],
	//=========================================================================
	data() {
		return {
			dateValue: null,
			timeValue: '00:00',
			valueSelected: false,

			showTimeChoicer: false,

			hTop: 0,
			hTimer: null,
			hModel: 0,
			hModelError: false,

			mTop: 0,
			mTimer: null,
			mModel: 0,
			mModelError: false,

			mouseWheelTimer: null,
			mouseWheelDelta: {
				'H': 0,
				'M': 0
			}
		}
	},
	//=========================================================================
	components: {
		Datepicker
	},
	//=========================================================================
	created() {
		this.init(this.value)
	},
	//=========================================================================
	mounted() {
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
	},
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
	},
	//=========================================================================
	watch: {
		value(val) {
			this.init(val)
		}
	},
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		init(value) {
			this.dateValue = null
			this.timeValue = '00:00'

			if (value)
			{
				let _div = value.indexOf(' ') > -1 ? ' ' : 'T'
				let _parts = value.split(_div)
				if (_parts[0] && /^\d{4}-\d{2}-\d{2}$/.test(_parts[0]))
				{
					this.dateValue = this.formater_StrDate2Date(_parts[0])
				}
				if (_parts[1] && /^\d{2}:\d{2}:\d{2}$/.test(_parts[1]))
				{
					this.timeValue = _parts[1].substr(0, 5)
				}
			}

			let h = this.timeValue.substr(0, 2)
			let m = this.timeValue.substr(-2)

			h = parseInt(h)
			m = parseInt(m)

			this.hModel = h
			this.mModel = m

			this.hModelError = false
			this.mModelError = false
		},
		//---------------------------------------------------------------------
		zeroTime() {
			this.timeValue = '00:00'
			this.hModel = 0
			this.mModel = 0
			this.hModelError = false
			this.mModelError = false
			this.$emit('input', this.makeValue())
		},
		//---------------------------------------------------------------------
		makeValue() {
			if (!this.dateValue) return null
			return this.formater_Date2StrDate(this.dateValue) + ' ' + this.timeValue + ':00'
		},
		//---------------------------------------------------------------------
		focusInput(what) {
			if (this.$refs['input' + what]) this.$refs['input' + what].select()
		},
		//---------------------------------------------------------------------
		onDateSelect(e)	{
			if (!e)	this.init()
			else
			{
				this.valueSelected = true
				let _val = this.formater_Date2StrDate(e) + ' ' + this.timeValue + ':00'
				this.init(_val)
			}

			this.$emit('input', this.makeValue())
		},
		//---------------------------------------------------------------------
		onDateOpen() {
			this.$emit('focus')
			if (!this.value)
			{
				let _val = this.formater_Date2StrDate(new Date(), true)
				this.init(_val)
			}
		},
		//---------------------------------------------------------------------
		onDateClose(e) {
			if (this.valueSelected)
			{
				this.valueSelected = false
				return
			}
			if (!this.value) this.init()
		},
		//---------------------------------------------------------------------
		onChangeModel(what) {
			let _val
			if (what === 'H')
			{
				this.hModelError = false
				_val = parseInt(this.hModel)
				if (isNaN(_val) || _val < 0 || _val > 23) this.hModelError = true
				else
				{
					this.hTop = -35 * _val
					this.$refs['hours'].style.top = this.hTop + 'px'
				}

				return
			}

			this.mModelError = false
			_val = parseInt(this.mModel)
			if (isNaN(_val) || _val < 0 || _val > 59) this.mModelError = true
			else
			{
				this.mTop = -35 * _val
				this.$refs['minutes'].style.top = this.mTop + 'px'
			}
		},
		//---------------------------------------------------------------------
		timeChoicerShow() {
			if (this.disabled) return
			let h = this.timeValue.substr(0, 2)
			let m = this.timeValue.substr(-2)

			h = parseInt(h)
			m = parseInt(m)

			this.hModel = h
			this.mModel = m

			this.hModelError = false
			this.mModelError = false

			this.hTop = -35 * h
			this.mTop = -35 * m

			this.$refs['hours'].style.top = this.hTop + 'px'
			this.$refs['minutes'].style.top = this.mTop + 'px'

			this.showTimeChoicer = true

			this.$emit('focus')
		},
		//---------------------------------------------------------------------
		timeChoicerValue() {
			let h = Math.abs(parseInt(this.hTop / 35))
			let m = Math.abs(parseInt(this.mTop / 35))
			this.hModel = h
			this.mModel = m
			this.hModelError = false
			this.mModelError = false
			if (h < 10) h = '0' + h
			if (m < 10) m = '0' + m
			return h + ':' + m
		},
		//---------------------------------------------------------------------
		timeChoiced() {
			if (this.hModelError || this.mModelError) return
			if (this.hTimer) clearInterval(this.hTimer)
			if (this.mTimer) clearInterval(this.mTimer)
			this.showTimeChoicer = false
			this.timeValue = this.timeChoicerValue()
			this.$emit('input', this.makeValue())
		},
		//---------------------------------------------------------------------
		timeCanceled() {
			if (this.hTimer) clearInterval(this.hTimer)
			if (this.mTimer) clearInterval(this.mTimer)
			this.showTimeChoicer = false
		},
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			if (e.keyCode === 27)
			{
				this.timeCanceled()
			}
		},
		//---------------------------------------------------------------------
		clickHandler(e) {
			if (e && e.target && e.target.tagName.toLowerCase() === 'span' && e.target.className.indexOf('datetime-component-time') > -1) return true
			this.timeCanceled()
		},
		//---------------------------------------------------------------------
		moveUpStart(what) {
			if (what === 'H')
			{
				if (this.hTimer) clearInterval(this.hTimer)
				this.hTimer = setInterval(() => {
					this.hTop -= 35
					if (this.hTop < -805) this.hTop = 0
					this.$refs['hours'].style.top = this.hTop + 'px'
					this.timeChoicerValue()
					this.hModelError = false
				}, 50)
				return
			}

			if (this.mTimer) clearInterval(this.mTimer)
			this.mTimer = setInterval(() => {
				this.mTop -= 35
				if (this.mTop < -2065) this.mTop = 0
				this.$refs['minutes'].style.top = this.mTop + 'px'
				this.timeChoicerValue()
				this.mModelError = false
			}, 50)
		},
		//---------------------------------------------------------------------
		moveStop(what) {
			if (what === 'H')
			{
				if (this.hTimer) clearInterval(this.hTimer)
			}
			else
			{
				if (this.mTimer) clearInterval(this.mTimer)
			}
		},
		//---------------------------------------------------------------------
		moveDownStart(what) {
			if (what === 'H')
			{
				if (this.hTimer) clearInterval(this.hTimer)
				this.hTimer = setInterval(() => {
					this.hTop += 35
					if (this.hTop > 0) this.hTop = -805
					this.$refs['hours'].style.top = this.hTop + 'px'
					this.timeChoicerValue()
					this.hModelError = false
				}, 50)
				return
			}

			if (this.mTimer) clearInterval(this.mTimer)
			this.mTimer = setInterval(() => {
				this.mTop += 35
				if (this.mTop > 0) this.mTop = -2065
				this.$refs['minutes'].style.top = this.mTop + 'px'
				this.timeChoicerValue()
				this.mModelError = false
			}, 50)
		},
		//---------------------------------------------------------------------
		moveBySteps(what, steps) {
			let _top

			if (what === 'H')
			{
				_top = this.hTop
				_top += steps * 35
				if (_top < -805) _top = 0
				if (_top > 0) _top = -805

				this.hTop = _top
				this.$refs['hours'].style.top = _top + 'px'
				this.timeChoicerValue()

				return
			}

			_top = this.mTop
			_top += steps * 35
			if (_top < -2065) _top = 0
			if (_top > 0) _top = -2065

			this.mTop = _top
			this.$refs['minutes'].style.top = _top + 'px'
			this.timeChoicerValue()
		},
		//---------------------------------------------------------------------
		mouseWheel(what, e) {
			let _delta = 0
			if (e && 'deltaY' in e) _delta = parseInt(e.deltaY)
			if (isNaN(_delta)) _delta = 0

			if (_delta > 0) this.mouseWheelDelta[what]++
			else this.mouseWheelDelta[what]--

			if (this.mouseWheelTimer) clearTimeout(this.mouseWheelTimer)
			this.mouseWheelTimer = setTimeout(() => {
				clearTimeout(this.mouseWheelTimer)
				this.moveBySteps(what, this.mouseWheelDelta[what])
				this.mouseWheelDelta[what] = 0
			}, 30)
		}
		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
div.datetime-component {
	width: 100%;
	font-size: 100%;
	appearance: none;
	outline: none;
	border: 1px solid #DDD;
	height: 3em;
	line-height: 1em;
	padding: 16px 20px 0 20px;
	border-radius: 4px;
	font-weight: 400;
	position: relative;
	color: #555;
	transition: box-shadow .3s;
	background-color: transparent;
}

.w5-disabled-field > div.datetime-component {
	background-color: #eee !important;
	color: black !important;
	border-color: #ccc !important;
}

.datetime-component-date-wrapper {
	display: inline-block;
}
.datetime-component-date-input {
	width: 115px !important;    
	height: auto !important;
	padding: 2px 10px !important;
	cursor: pointer;
}


span.datetime-component-time {	
	position: relative;
	margin-left: 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 2px 10px;
	cursor: pointer;
}
span.view-close {
	margin-left: 10px;
	cursor: pointer;
	color: #ccc;

}
span.view-close:hover, span.view-close:focus {
	color: #000;
}

div.datetime-component-time-choice {
	position: absolute;
	width: 140px;
	height: 175px;
	border: 1px solid #ddd;
	border-radius: 4px;
	top: 23px;
	left: 0;
	z-index: 100;
	background-color: white;
	overflow: hidden;
}

.datetime-component-time-choice-spiners {
	width: 100%;
	height: 140px;
	overflow: hidden;
}

.datetime-component-time-choice-button {
	text-align: center;	
	width: 100%;
	height: 34px;
	line-height: 34px;
	font-size: 80%;
	font-weight: 500;
	cursor: pointer;
	background: #2c8ad8;
    border: 1px solid #2c8ad8;
    color: white;
}
.datetime-component-time-choice-button:hover {
	background-color: #3ba3ff;
    border-color: #3ba3ff;
}

.datetime-component-time-choice-spiners-hours {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;	
	transition: all 0.2s;
}

.datetime-component-time-choice-spiners-minutes {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	transition: all 0.2s;
}

.datetime-component-time-choice-spiners-button,
.datetime-component-time-choice-spiners-item {	
	position: relative;
	text-align: center;
	padding: 10px 0;
	user-select: none;	
	height: 35px;
	overflow: hidden;
}

.datetime-component-time-choice-spiners-button {
	font-size: 80%;
	color: #ccc;
	cursor: pointer;
}
.datetime-component-time-choice-spiners-button:hover {
	color: black;
}

.datetime-component-time-wrapper:hover .datetime-component-time-choice-spiners-hours,
.datetime-component-time-wrapper:hover .datetime-component-time-choice-spiners-minutes {
	font-size: 140%;
	font-weight: 500;
	background-color: #2c8ad8;
	color: white;
}

.datetime-component-time-input {
	text-align: center;
	position: relative;        
    height: 35px;
}

.datetime-component-time-input > input {
	width: 40px !important;
	margin: 4px 0;
	height: 27px  !important;
	line-height: 27px !important;
	padding: 1px 0 0 0 !important;
	text-align: center;
}

.datetime-component-time-input.haserror > input {
	border: 1px solid #f72b2b !important;
}

.datetime-component-time-input.haserror > input:focus {
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .2), 0 0 6px #f79b9b !important;
}

.datetime-component-time.focused {
	border-color: #66afe9;
	box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);	
}

.datetime-component-date-wrapper.readonly input,
.datetime-component-time.readonly {
	border: none !important;
	padding-left: 0 !important;
	margin-left: 0 !important;
	color: #999 !important;
	cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// datetime.vue?5ad3a41e